import type { Topic } from '@snapchat/mw-contentful-schema';
import { createContext } from 'react';

import type { BreadcrumbsDataProps } from '../Breadcrumbs';
import type { ReplacementMap } from '../Experiment';

interface SlugContextProps {
  isShareable: boolean;
  publishedAt?: Date;
  postedDate?: Date;
  replacements?: ReplacementMap;
  breadcrumbData?: BreadcrumbsDataProps;
  topics?: Topic[];
  slugId?: string;
}

export const SlugContext = createContext<SlugContextProps>({
  isShareable: false,
});
